import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { toast } from 'sonner';
import http from '@/lib/http';

const usePublicSettingsStore = create(
  devtools((set) => ({
    tokenSymbol: null,
    loading: false,
    error: null,

    fetchPublicSettings: async () => {
      set({ loading: true, error: null });

      try {
        const { data } = await http.get('/public/settings');
        set({
          tokenSymbol: data?.tokenSymbol || null,
          loading: false,
        });
      } catch (error) {
        const errorMessage =
          error?.response?.data?.error || 'Failed to load token symbol';
        set({ error: errorMessage, loading: false });
        toast.error(errorMessage);
      }
    },
  }))
);

export default usePublicSettingsStore;
